<template>
  <div class="flex flex-col gap-2 mb-4">
    <h3 class="inline-block uppercase text-[14px] tracking-[0.42px] font-bold" v-if="objectType.toLowerCase() == 'apartment'">Bostadstyp</h3>
    <h3 class="inline-block uppercase text-[14px] tracking-[0.42px] font-bold" v-if="objectType.toLowerCase() == 'parking'">Typ av parkeringsplats</h3>
    <div class="flex flex-wrap gap-2">
      <Button
        v-if="allObjects"
        @click="clicked('all')"
        :variant="
          Object.keys(isClicked).length == availableObjectTypes.length ||
          !Object.keys(isClicked).length
            ? 'primary'
            : 'secondarysearch'
        "
      >
        Alla ({{ allObjects.length }})
      </Button>
      <Button
        v-if="!allObjects"
        @click="clicked('all')"
        :variant="
          Object.keys(isClicked).length == availableObjectTypes.length ||
          !Object.keys(isClicked).length
            ? 'primary'
            : 'secondarysearch'
        "
      >
        Alla
      </Button>
      <Button
        v-for="item in availableObjectTypes"
        @click="clicked(item.code, item.caption)"
        :variant="isClicked && isClicked[item.code] == true ? 'primary' : 'secondarysearch'"
      >
        {{ item.caption }}
        <span v-if="allObjects">({{ item.numitems }})</span>
      </Button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { filter, isEmpty, reject } from 'lodash';
import { RENTALOBJECT_TYPES } from '@/config/constants';
import { map, forEach } from 'lodash';
import { dataLayerPush } from '@/helpers/datalayer';
import { RENTALOBJECT_TYPE_CODES, PARKING_FILTER_TYPES } from '@/config/constants';
import Button from '@/components/ui/button';

export default {
  name: 'ObjectTypes',
  components: {
    Button,
  },
  props: {
    modelValue: {
      type: Array,
    },
    objectType: {
      type: String,
      default: RENTALOBJECT_TYPES.APARTMENT,
    },
    vehicleType: {
      type: String,
    },
    allObjects: {
      required: false,
    },
    activeFilters: {
      required: false,
      default: [],
    },
    subscription: {
      type: Boolean,
    },
    createForm: {
      type: Boolean,
    },
  },
  data() {
    return {
      /**
       * Inskickat prop får inte manipuleras. Därför klonas den (eller va gör data() med den?)
       */
      value__: [],
      isClicked: [],
      PARKING_FILTER_TYPES,
      setType: undefined,
    };
  },
  computed: {
    ...mapGetters(['config']),

    /**
     * Alternativ att välja bland
     */
    availableObjectTypes() {
      if (this.objectType == RENTALOBJECT_TYPES.APARTMENT) {
        return filter(this.$store.getters.config.rentalObjectTypes, (rentalObjectType) => {
          return (
            rentalObjectType.published == true &&
            rentalObjectType.code.includes('LGH') &&
            !rentalObjectType.code.includes(RENTALOBJECT_TYPE_CODES.STUDENTBOSTAD)
          );
        });
      }

      if (this.objectType == RENTALOBJECT_TYPES.PARKING) {
        if (!this.setType && !this.vehicleType) {
          if (
            !!this.subscription &&
            Array.isArray(this.activeFilters.rentalObjectTypes) &&
            this.activeFilters.rentalObjectTypes.length > 0 &&
            !this.vehicleType
          ) {
            if (PARKING_FILTER_TYPES['BOAT'].includes(this.activeFilters.rentalObjectTypes[0]))
              this.setType = 'BOAT';
            else if (PARKING_FILTER_TYPES['MC'].includes(this.activeFilters.rentalObjectTypes[0]))
              this.setType = 'MC';
            else this.setType = 'CAR';
          } else {
            // if(!this.vehicleType) this.vehicleType = 'CAR';
            this.setType = this.vehicleType;
            if (!this.setType) this.setType = 'CAR';
          }
        } else if (this.vehicleType) {
          this.setType = this.vehicleType;
        }

        return filter(this.$store.getters.config.vehicleSpaceTypes, (vehicleSpaceType) => {
          if (PARKING_FILTER_TYPES[this.setType].includes(vehicleSpaceType.code)) {
            return true;
          }
        });
      }

      throw new Error("Felaktigt val 'type' ");
    },
  },
  watch: {
    /**
     * När v-model ändras, ska även det interna värdet ändras.
     * Detta sker t.ex. när man klickar på "Rensa"-knappen
     *
     */
    '$route.query.rentalObjectTypes': {
      immediate: true,
      handler(rentalObjectTypes) {
        if (
          !isEmpty(rentalObjectTypes) &&
          rentalObjectTypes.includes('LGH9') &&
          !this.isClicked['LGH9']
        ) {
          this.clicked('LGH9', 'Nyproduktion');
        }
      },
    },

    availableObjectTypes: {
      handler(oldValue, newValue) {
        this.setFilterCount();
      },
    },
    allObjects: function (newVal, oldVal) {
      // watch it
      this.setFilterCount();
    },

    modelValue: {
      handler() {
        if (Object.keys(this.modelValue).length === 0) {
          this.value__ = [];
          this.isClicked = [];
        } else {
          /**
           * När component skapas, kan v-model vara typ ["LGH1"].
           * Men internt behandlas varje objectType som ett object.
           * Därför måste en mappning ske vid start för att förvalda värden ska finnas
           */
          this.value__ = [];
          forEach(this.availableObjectTypes, (obj) => {
            if (
              this.modelValue.indexOf(obj.code.toLowerCase()) > -1 ||
              this.modelValue.indexOf(obj.code) > -1
            ) {
              this.isClicked[obj.code] = true;
              this.value__.push(obj);
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created: function () {
    let arr = [];
    if (typeof this.activeFilters.rentalObjectTypes == 'string') {
      arr.push(this.activeFilters.rentalObjectTypes);
    } else {
      Object.keys(this.activeFilters.rentalObjectTypes).forEach((key) => {
        arr.push(this.activeFilters.rentalObjectTypes[key]);
      });
    }
    this.$emit('update:modelValue', arr);
  },
  mounted: function () {
    if (this.$route.query.rentalObjectTypes) {
      if (
        !isEmpty(this.$route.query.rentalObjectTypes) &&
        this.$route.query.rentalObjectTypes.includes('LGH9') &&
        !this.isClicked['LGH9']
      ) {
        this.clicked('LGH9', 'Nyproduktion');
      }
    }
  },

  methods: {
    setFilterCount() {
      forEach(this.availableObjectTypes, (obj) => {
        let c = 0;
        forEach(this.allObjects, (o) => {
          if (o.rentalObjectType.toLowerCase() == obj.code.toLowerCase()) c++;
        });
        obj.numitems = c ? c : 0;
      });

      //loopa igenom alla filter

      //för varje filter, loopa igenom alla objekt och räkna antal som hör till filtret

      //uppdatera sen texten som hör till filtret item.numitems
    },

    isActive(itemCode) {
      if (
        this.activeFilters.rentalObjectTypes[itemCode] == true ||
        this.activeFilters.rentalObjectTypes.includes(itemCode)
      )
        return true;
      else return false;
    },

    clicked(index, caption) {
      if (index === 'all') {
        this.isClicked = {}; // Reset all
      } else {
        // Toggle the state
        this.isClicked = { ...this.isClicked, [index]: !this.isClicked[index] };
      }

      dataLayerPush({ event: 'bostadstyp', buttonText: caption });

      // Emit a new array of active object codes
      const activeCodes = Object.keys(this.isClicked).filter((key) => this.isClicked[key]);
      this.$emit('update:modelValue', activeCodes);
    },
  },
};
</script>
